// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DefaultTheme__spinner___1ZqfV {
    animation: DefaultTheme__spin___2BLHD 0.8s infinite linear;
  }

    .DefaultTheme__spinner___1ZqfV.DefaultTheme__s___1Ezcf {
      width: 20px;
      height: 20px;
      border-left: calc(20px / 10) solid transparent;
      border-right: calc(20px / 10) solid transparent;
      border-bottom: calc(20px / 10) solid transparent;
      border-top: calc(20px / 10) solid var(--_apc-spinner-line-color, var(--primary));
      border-radius: 100%;
    }

    .DefaultTheme__spinner___1ZqfV.DefaultTheme__m___FFO2l {
      width: 40px;
      height: 40px;
      border-left: calc(40px / 10) solid transparent;
      border-right: calc(40px / 10) solid transparent;
      border-bottom: calc(40px / 10) solid transparent;
      border-top: calc(40px / 10) solid var(--_apc-spinner-line-color, var(--primary));
      border-radius: 100%;
    }

    .DefaultTheme__spinner___1ZqfV.DefaultTheme__l___3u_d- {
      width: 80px;
      height: 80px;
      border-left: calc(80px / 10) solid transparent;
      border-right: calc(80px / 10) solid transparent;
      border-bottom: calc(80px / 10) solid transparent;
      border-top: calc(80px / 10) solid var(--_apc-spinner-line-color, var(--primary));
      border-radius: 100%;
    }

@keyframes DefaultTheme__spin___2BLHD {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(359deg);
  }
}
`, "",{"version":3,"sources":["webpack://./../node_modules/@mulesoft/anypoint-components/raw/components/Spinner/themes/DefaultTheme.css"],"names":[],"mappings":"AAAA;IACI,0DAA0D;EAC5D;;IAEE;MACE,WAAW;MACX,YAAY;MACZ,8CAA8C;MAC9C,+CAA+C;MAC/C,gDAAgD;MAChD,gFAAgF;MAChF,mBAAmB;IACrB;;IAEA;MACE,WAAW;MACX,YAAY;MACZ,8CAA8C;MAC9C,+CAA+C;MAC/C,gDAAgD;MAChD,gFAAgF;MAChF,mBAAmB;IACrB;;IAEA;MACE,WAAW;MACX,YAAY;MACZ,8CAA8C;MAC9C,+CAA+C;MAC/C,gDAAgD;MAChD,gFAAgF;MAChF,mBAAmB;IACrB;;AAEJ;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":[".DefaultTheme__spinner___1ZqfV {\n    animation: DefaultTheme__spin___2BLHD 0.8s infinite linear;\n  }\n\n    .DefaultTheme__spinner___1ZqfV.DefaultTheme__s___1Ezcf {\n      width: 20px;\n      height: 20px;\n      border-left: calc(20px / 10) solid transparent;\n      border-right: calc(20px / 10) solid transparent;\n      border-bottom: calc(20px / 10) solid transparent;\n      border-top: calc(20px / 10) solid var(--_apc-spinner-line-color, var(--primary));\n      border-radius: 100%;\n    }\n\n    .DefaultTheme__spinner___1ZqfV.DefaultTheme__m___FFO2l {\n      width: 40px;\n      height: 40px;\n      border-left: calc(40px / 10) solid transparent;\n      border-right: calc(40px / 10) solid transparent;\n      border-bottom: calc(40px / 10) solid transparent;\n      border-top: calc(40px / 10) solid var(--_apc-spinner-line-color, var(--primary));\n      border-radius: 100%;\n    }\n\n    .DefaultTheme__spinner___1ZqfV.DefaultTheme__l___3u_d- {\n      width: 80px;\n      height: 80px;\n      border-left: calc(80px / 10) solid transparent;\n      border-right: calc(80px / 10) solid transparent;\n      border-bottom: calc(80px / 10) solid transparent;\n      border-top: calc(80px / 10) solid var(--_apc-spinner-line-color, var(--primary));\n      border-radius: 100%;\n    }\n\n@keyframes DefaultTheme__spin___2BLHD {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(359deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
